import { GLSettingsUsers } from "@group-link-one/grouplink-components";

import { UsersContent } from "./Content/usersContent";
import { useOrganizationUsers } from "./useOrganizationUsers";

export const UsersPage = () => {
  const {
    activeUserById,
    createUserInvite,
    deactivateUserById,
    deleteInviteById,
    updateRole,
  } = useOrganizationUsers();

  return (
    <GLSettingsUsers
      onlyBetaPrivileges
      onActiveUserById={activeUserById}
      onCreateUserInvite={createUserInvite}
      onDeactivateUserById={deactivateUserById}
      onDeleteInviteById={deleteInviteById}
      onChangeRole={updateRole}
    >
      <UsersContent />
    </GLSettingsUsers>
  );
};
